import { StackScreen } from '@banhala/ui-kit';
import { useState } from 'react';
import { MenuProvider } from 'react-native-popup-menu';
import { CartIcon, SearchIcon } from 'shared/src/component';
import { AnalyticsScreen } from 'shared/src/context';
import { LikeContents } from './components';
import { LIKE_TABS } from './constants';

export const LikeScreen = () => {
  const { item_list, selected_id } = LIKE_TABS;
  const [index, setIndex] = useState(() =>
    item_list.findIndex(item => item.id === selected_id),
  );
  const screenName = item_list[index]?.screen_name ?? '';

  return (
    <AnalyticsScreen screen={screenName} hostsModals={false}>
      {/* 컨텍스트 메뉴 좌표 기준이 화면 루트가 되도록 최상단에 배치 */}
      <MenuProvider>
        <StackScreen
          title={'찜'}
          hideBackButton={true}
          rightIcons={[<SearchIcon />, <CartIcon />]}
        >
          <LikeContents
            tabs={item_list}
            index={index}
            onIndexChange={setIndex}
          />
        </StackScreen>
      </MenuProvider>
    </AnalyticsScreen>
  );
};
